import {
  Component,
  OnInit,
  EventEmitter,
  Output,
  ElementRef,
  ViewChild,
  Input,
  SimpleChanges,
  OnChanges,
} from "@angular/core";
import { Project } from "@src/app/models/project";
import { Organization } from "@src/app/models/organization";
import { ProjectaddService } from "./service/projectadd.service";
import { SessionHelper } from "@src/app/helpers/sessionHelper";
import { Customer } from "./model/customer";
import { AuthorizationService } from "@src/app/helpers/authorization.service";
import { Customerdeal } from "@src/app/models/customerdeal";
import { DatastoreService } from "@src/app/helpers/datastore/datastore.service";

import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";

@UntilDestroy({ checkProperties: true })
@Component({
  selector: "app-orgprojectadd",
  templateUrl: "./orgprojectadd.component.html",
  styleUrls: ["./orgprojectadd.component.css"],
})
export class OrgprojectaddComponent implements OnInit, OnChanges {
  project: Project;
  step: Number = 1;
  @Input() wizard: boolean;
  @Input() dealId: string;
  @Input() customerId: string;
  @Output() projecttoadd = new EventEmitter<Project>();
  @Output() setProjectload = new EventEmitter<boolean>();
  customerList: Customer[];
  @ViewChild("projectmodalclose", { static: true })
  projectmodalclose: ElementRef;
  errorMessage: string;
  @Output() showSpinner: boolean;
  formIsValid: boolean;
  showCustomerCreate: boolean;
  dealList: Customerdeal[];

  constructor(
    private tasrv: ProjectaddService,
    private auth: AuthorizationService,
    private datastore: DatastoreService
  ) {}

  ngOnInit() {
    //console.log('ngOnInit');
    this.project.start_date = new Date();
    this.project.end_date = new Date();

    this.formIsValid = false;
    this.showSpinner = false;
    this.showCustomerCreate = false;
    this.step = 1;

    this.project = new Project();
    this.project.customer = this.customerId;
    this.project.dealId = this.dealId;
    this.project.organizationId = SessionHelper.getChoosenOrg();
    this.project.start_date = new Date();
   //console.log("project", this.project);
    //   if(this.customerId != undefined){
    //     this.setCustomer(this.project.customer);
    //     this.project.customer = this.customerId
    //   }
    //   if(this.dealId != undefined){
    //     this.project.dealId = this.dealId
    //  }
  }

  ngOnChanges(changes: SimpleChanges) {
    //console.log('ngOnChanges',changes);
    if (!this.project) {
      this.project = new Project();
    }
    if (!this.customerList) {
      this.datastore.customers$
        .pipe(untilDestroyed(this))
        .subscribe((clist) => {
          //this.tasrv.getCustomers().pipe(untilDestroyed(this)).subscribe(clist => {
          clist.forEach(cust => {
            cust.customerId = cust.customerId.split("_")[0];
          });
          this.customerList = clist;
         //console.log("customerList", this.customerList);
        });
    }
    if (
      changes.customerId &&
      changes.customerId.currentValue &&
      changes.customerId.currentValue != changes.customerId.previousValue
    ) {
      this.project.customer = changes.customerId.currentValue;
      this.setCustomer(this.project.customer);
    }
    if (
      changes.dealId &&
      changes.dealId.currentValue &&
      changes.dealId.currentValue != changes.dealId.previousValue
    ) {
      this.project.dealId = changes.dealId.currentValue;
    }
  }
  setCustomer(customerId: string) {
    //get deals for customer
    this.tasrv
      .getDeals(customerId.split('_')[0], new Date().toISOString())
      .pipe(untilDestroyed(this))
      .subscribe((deals) => {
        this.dealList = deals;
      });
  }
  closeModal() {
    this.formIsValid = false;
    this.showSpinner = false;
    this.showCustomerCreate = false;
    this.step = 1;

    this.project = new Project();
  }

  createProject() {
    if (
      !this.project.title ||
      !this.project.end_date ||
      !this.project.start_date ||
      !this.project.projectdescription ||
      !this.project.customer
    ) {
      this.errorMessage = "modalvalidation.requiredfieldmissing";
    } else {
      this.setProjectload.emit(true);
     //console.log("createProject", this.project);
      this.tasrv
        .getOrg()
        .pipe(untilDestroyed(this))
        .subscribe((org) => {
          this.project.organizationname = org.organizationname;
          this.project.orgdesc = org.orgdesc;
          this.project.orgwww = org.www;
          this.project.orgemail = org.email;
          this.project.orglogourl = org.logourl;

          this.project.fullname = JSON.parse(
            SessionHelper.getPerson()
          ).fullname;
          this.project.projectscope = "organization";
          this.project.creator = SessionHelper.getUserSub();
          this.project.created = new Date();
          this.project.projectlocation = "not set";
          this.showSpinner = true;
          this.project.subtitle = "-";
          this.project.shortdescription = "-";
          this.project.created = new Date();
          this.project.customername =
            this.customerList[
              this.customerList.findIndex(
                (cust) => cust.customerId.split("_")[0] == this.project.customer
              )
            ].title;
          this.project.projectdescription = this.project.projectdescription
            ? this.project.projectdescription
            : " ";
          if (this.project.dealId && this.dealList.length > 0) {
            this.project.dealcrmId =
              this.dealList[
                this.dealList.findIndex(
                  (deal) =>
                    deal.dealId.split("_")[0] ==
                    this.project.dealId.split("_")[0]
                )
              ].dealcrmId;
          }
         //console.log("project", this.project);
          //this.project.dealcrmId = this.dealList[this.dealList.findIndex(deal => deal.dealId.split('_')[0] == this.project.dealId.split('_')[0])].dealcrmId;
          this.tasrv
            .createProject(this.project)
            .pipe(untilDestroyed(this))
            .subscribe((result) => {
              this.project.projectId = result.newProjectId;
              //console.log('project created',this.project);
              //this.step = 2;
              this.projecttoadd.emit(this.project);
              //this.ngOnInit();
              if (!this.wizard) {
                this.projectmodalclose.nativeElement.click();
              }

              // setTimeout(() => {
              //   this.auth.refreshPersonAuth(SessionHelper.getUserSub());
              // }, 2500);

              this.project = new Project();
              this.project.organizationId = SessionHelper.getChoosenOrg();

              this.project.organizationname = org.organizationname;
              this.project.orgdesc = org.orgdesc;
              this.project.orgwww = org.www;
              this.project.orgemail = org.email;
              this.project.orglogourl = org.logourl;

              this.project.fullname = JSON.parse(
                SessionHelper.getPerson()
              ).fullname;
              this.project.projectscope = "organization";
              this.project.creator = SessionHelper.getUserSub();
              this.project.created = new Date();

              this.project.projectlocation = "not set";

              this.datastore.customers$
                .pipe(untilDestroyed(this))
                .subscribe((clist) => {
                  //this.tasrv.getCustomers().pipe(untilDestroyed(this)).subscribe(clist => {
                  this.customerList = clist;
                });
              this.setProjectload.emit(false);
              this.showSpinner = false;
            });
        });
    }
  }
  // addInterest(projectInterestTooAdd:Projectinterest){
  //   this.projectintersttoadd = projectInterestTooAdd;
  // }
  validate() {
    if (
      this.project.start_date &&
      this.project.end_date &&
      this.project.title
    ) {
      this.formIsValid = true;
    } else {
      this.formIsValid = false;
    }
  }
  openCreateCustomer() {
    this.showCustomerCreate = true;
  }
  addCustomer(cust: Customer) {
    if (cust != null) {
      this.customerList.push(cust);
      this.project.customer = cust.customerId;
      this.project.customername =
        this.customerList[
          this.customerList.findIndex(
            (custo) => custo.customerId == this.project.customer
          )
        ].title;
    }

    this.showCustomerCreate = false;
  }
}
